import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { dashboardActions as actions, notificationActions } from '../actions';
import { dashboardService } from '../services';

/* Add Designation Sagas */
function* handleEmployeeRequestPendingRequest() {
    const action = yield take(actions.employeeRequestPendingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeRequestPending, dataParams);
        if (res.isError) {
            yield put(actions.employeeRequestPendingError(res));

        } else {
            yield put(actions.employeeRequestPendingSuccess(res));
        }
    } catch (error) {
        yield put(actions.employeeRequestPendingError());
    }
}


/* Get Designation By Department Sagas */
function* handleEmployeeCorrectionCountRequest() {
    const action = yield take(actions.employeeCorrectionCountRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeCorrectionCount, dataParams);
        if (res.isError) {
            yield put(actions.employeeCorrectionCountError(res));

        } else {
            yield put(actions.employeeCorrectionCountSuccess(res));
        }

    } catch (error) {
        yield put(actions.employeeCorrectionCountError());
    }
}

/* Update Designation Sagas */
function* handleEmployeeWeeklyAttendanceTrendRequest() {
    const action = yield take(actions.employeeWeeklyAttendanceTrendRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeWeeklyAttendanceTrend, dataParams);
        if (res.isError) {
            yield put(actions.employeeWeeklyAttendanceTrendError(res));
        } else {
            yield put(actions.employeeWeeklyAttendanceTrendSuccess(res));
        }
    } catch (error) {
        yield put(actions.employeeWeeklyAttendanceTrendError());
    }
}
/* Employee Attendance Statistics Sagas */
function* handleEmployeeAttendanceStatisticsRequest() {
    const action = yield take(actions.employeeAttendanceStatisticsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeAttendanceStatistics, dataParams);
        if (res.isError) {
            yield put(actions.employeeAttendanceStatisticsError(res));
        } else {
            yield put(actions.employeeAttendanceStatisticsSuccess(res));
        }
    } catch (error) {
        yield put(actions.employeeAttendanceStatisticsError());
    }
}

/* Get All Designation Sagas */
function* handleEmployeeLeavesStatisticsRequest() {
    const action = yield take(actions.employeeLeavesStatisticsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeLeavesStatistics, dataParams);
        if (res.isError) {
            yield put(actions.employeeLeavesStatisticsError(res));

        } else {
            yield put(actions.employeeLeavesStatisticsSuccess(res));
        }

    } catch (error) {
        yield put(actions.employeeLeavesStatisticsError());
    }
}

/* Get Announcement Count Sagas */
function* handleGetAnnouncementCountRequest() {
    const action = yield take(actions.getAnnouncementCountRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.getAnnouncementCount, dataParams);
        if (res.isError) {
            yield put(actions.getAnnouncementCountError(res));

        } else {
            yield put(actions.getAnnouncementCountSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAnnouncementCountError());
    }
}



/* Get Announcement Count Sagas */
function* handleEmployeeAttendanceCountRequest() {
    const action = yield take(actions.employeeAttendanceCountRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeAttendanceCount, dataParams);
        if (res.isError) {
            yield put(actions.employeeAttendanceCountError(res));

        } else {
            yield put(actions.employeeAttendanceCountSuccess(res));
        }

    } catch (error) {
        yield put(actions.employeeAttendanceCountError());
    }
}

/* Get Announcement Count Sagas */
function* handleEmployeeAttendanceRequest() {
    const action = yield take(actions.employeeAttendanceRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeAttendance, dataParams);
        if (res.isError) {
            yield put(actions.employeeAttendanceError(res));

        } else {
            yield put(actions.employeeAttendanceSuccess(res));
        }

    } catch (error) {
        yield put(actions.employeeAttendanceError());
    }
}

/* Get Announcement Count Sagas */
function* handleGetEmployeeAttendanceStatusRequest() {
    const action = yield take(actions.getEmployeeAttendanceStatusRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.getEmployeeAttendanceStatus, dataParams);
        if (res.isError) {
            yield put(actions.getEmployeeAttendanceStatusError(res));

        } else {
            yield put(actions.getEmployeeAttendanceStatusSuccess(res));
        }

    } catch (error) {
        yield put(actions.getEmployeeAttendanceStatusError());
    }
}

/* Get Announcement Count Sagas */
function* handleEmployeeLeaveOrTimeOffRequest() {
    const action = yield take(actions.employeeLeaveOrTimeOffRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.employeeLeaveOrTimeOff, dataParams);
        if (res.isError) {
            yield put(actions.employeeLeaveOrTimeOffError(res));

        } else {
            yield put(actions.employeeLeaveOrTimeOffSuccess(res));
        }

    } catch (error) {
        yield put(actions.employeeLeaveOrTimeOffError());
    }
}

/* Get Today Present Employee Sagas */
function* handleTodayPresentEmployeeRequest() {
    const action = yield take(actions.todayPresentEmployeeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dashboardService.todayPresentEmployee, dataParams);
        if (res.isError) {
            yield put(actions.todayPresentEmployeeError(res));

        } else {
            yield put(actions.todayPresentEmployeeSuccess(res));
        }

    } catch (error) {
        yield put(actions.todayPresentEmployeeError());
    }
}


/* -----------Watchers------------- */
function* handleEmployeeRequestPendingWatcher() {
    yield takeEvery(
        actions.employeeRequestPendingRequest,
        handleEmployeeRequestPendingRequest,
    );
}

function* handleEmployeeCorrectionCountWatcher() {
    yield takeEvery(
        actions.employeeCorrectionCountRequest,
        handleEmployeeCorrectionCountRequest,
    );
}

function* handleEmployeeWeeklyAttendanceTrendWatcher() {
    yield takeEvery(
        actions.employeeWeeklyAttendanceTrendRequest,
        handleEmployeeWeeklyAttendanceTrendRequest,
    );
}

function* handleEmployeeAttendanceStatisticsWatcher() {
    yield takeEvery(
        actions.employeeAttendanceStatisticsRequest,
        handleEmployeeAttendanceStatisticsRequest,
    );
}
function* handleEmployeeLeavesStatisticsWatcher() {
    yield takeEvery(
        actions.employeeLeavesStatisticsRequest,
        handleEmployeeLeavesStatisticsRequest,
    );
}

function* handleGetAnnouncementCountWatcher() {
    yield takeEvery(
        actions.getAnnouncementCountRequest,
        handleGetAnnouncementCountRequest,
    );
}


function* handleEmployeeAttendanceCountWatcher() {
    yield takeEvery(
        actions.employeeAttendanceCountRequest,
        handleEmployeeAttendanceCountRequest,
    );
}

function* handleEmployeeAttendanceWatcher() {
    yield takeEvery(
        actions.employeeAttendanceRequest,
        handleEmployeeAttendanceRequest,
    );
}


function* handleGetEmployeeAttendanceStatusWatcher() {
    yield takeEvery(
        actions.getEmployeeAttendanceStatusRequest,
        handleGetEmployeeAttendanceStatusRequest,
    );
}

function* handleEmployeeLeaveOrTimeOffWatcher() {
    yield takeEvery(
        actions.employeeLeaveOrTimeOffRequest,
        handleEmployeeLeaveOrTimeOffRequest,
    );
}

function* handleTodayPresentEmployeeWatcher() {
    yield takeEvery(
        actions.todayPresentEmployeeRequest,
        handleTodayPresentEmployeeRequest,
    );
}

function* rootDashboardSaga() {
    yield all([
        handleEmployeeRequestPendingRequest(),
        handleEmployeeRequestPendingWatcher(),

        handleEmployeeCorrectionCountRequest(),
        handleEmployeeCorrectionCountWatcher(),

        handleEmployeeWeeklyAttendanceTrendRequest(),
        handleEmployeeWeeklyAttendanceTrendWatcher(),

        handleEmployeeAttendanceStatisticsRequest(),
        handleEmployeeAttendanceStatisticsWatcher(),

        handleEmployeeLeavesStatisticsRequest(),
        handleEmployeeLeavesStatisticsWatcher(),

        handleGetAnnouncementCountRequest(),
        handleGetAnnouncementCountWatcher(),

        handleEmployeeAttendanceCountRequest(),
        handleEmployeeAttendanceCountWatcher(),

        handleEmployeeAttendanceRequest(),
        handleEmployeeAttendanceWatcher(),

        handleGetEmployeeAttendanceStatusRequest(),
        handleGetEmployeeAttendanceStatusWatcher(),

        handleEmployeeLeaveOrTimeOffRequest(),
        handleEmployeeLeaveOrTimeOffWatcher(),

        handleTodayPresentEmployeeRequest(),
        handleTodayPresentEmployeeWatcher(),


    ]);
}

export default rootDashboardSaga;
